<input
  #fileInput
  type="file"
  style="display: none"
  (change)="uploadDocOnField()"
  multiple
  />
<app-modal
  #deleteAttachmentModal
  [modalMessage]="app.text.attachments.deleteQuestion"
  [modalTitle]="app.text.attachments.modalTitle"
  (ok)="app.field.deleteDocAttachedToField()"
></app-modal>
<div
  [ngClass]="{
    odd: (index % 2) + 1 === 1 && showLabel && !noStriped,
    lightGrey: lightOddField
  }"
  (click)="onFieldClicked($event)"
  >
  <div
    class="row app-field"
    [ngClass]="{ 'no-gutters': shadowInput || isFinalSolutin }"
    >
    @if (showLabel) {
      <div
        [title]="app.field.getTooltip(field)"
        [ngClass]="getLabelStyle()"
        >
        <div class="fieldName">
          {{ app.field.getLabel(field) }}
          @if (app.field.getHelperText(field) !== '') {
            <span class="helperText">
              {{ app.field.getHelperText(field) }}</span
              >
            }
          </div>
          @if (!disabled) {
            <div class="float-end">
              @if (app.field.isMultiple(field)) {
                <div class="highlight-text">
                  {{ app.text.field.multiselect }}
                </div>
              }
            </div>
          }
        </div>
      }
      <div
        [ngClass]="getInputStyle()"
        (click)="click(field); app.field.current = field"
        id="{{ field }}"
        >
        @if (
          labelInside &&
          app.field.getFieldSettings(field).type !== 'user-options'
          ) {
          <div
            class="fieldLabel custom-label"
            [title]="app.field.getTooltip(field)"
            [hidden]="hideLabel(model[field])"
            >
            <div
              class="custom-field"
          [ngClass]="{
            fieldName: !orangeField,
            orangeLabel: orangeField
          }"
              >
              {{ app.field.getLabel(field) }}
            </div>
            @if (!disabled) {
              <div class="multiselect">
                @if (app.field.isMultiple(field)) {
                  <div class="highlight-text">
                    {{ app.text.field.multiselect }}
                  </div>
                }
              </div>
            }
          </div>
        }

        <div
          class="fieldValue"
          [ngClass]="createClass()"
          [title]="app.field.getTooltip(field)"
          >
          @switch (app.field.getType(field)) {
            <!-- DATE -->
            @case ('timestamp') {
              <div
                class="lineHeight dateContainer"
          [ngClass]="{
            underline: showUnderline(),
            'underline-red': isMandatory()
          }"
                >
                <!-- Read Mode -->
                @if (model[field] > 0 && isDisabled()) {
                  <button
                    class="btn btn-sm"
                    [ngStyle]="app.field.getDateColor(field, model)"
                    >
                    {{ model[field] | date: "yyyy-MM-dd" : "UTC" }}
                  </button>
                }
                <!-- Edit Mode -->
                <form class="form-inline">
                  <div class="form-group position-relative">
                    @if (!isDisabled()) {
                      <input
                        class="form-control flex-grow-1"
                        [(ngModel)]="model[field]"
                        name="d"
                        ngbDatepicker
                        #d="ngbDatepicker"
                        (click)="onInputClick(d, field)"
                        readonly
                        />
                    }
                    <!-- Clear X button -->
                    @if (model[field] > 0) {
                      <button
                        class="btn clear-date"
                        type="button"
                (click)="
                  clearDateModel(field); d.open(); $event.stopPropagation()
                "
                        >
                        <i class="fas fa-times"></i>
                      </button>
                    }
                    <!-- Calendar button -->
                    @if (!isDisabled()) {
                      <button
                        class="btn btn-sm calendar-btn"
                (click)="
                  d.toggle(); setMultipleFocus(field); $event.stopPropagation()
                "
                        >
                        <i class="fa fa-calendar"></i>
                      </button>
                    }
                  </div>
                </form>
                <!-- Different Display -->
                @if (
                  differentDisplay && model[field] != null && model[field] !== ''
                  ) {
                  <button
                    class="btn btn-sm m-0 m-0 pull-right"
                    type="button"
                    (click)="app.filterList.add()"
                    >
                    <i class="fa fa-search"></i>
                  </button>
                }
                <!-- Mandatory indicator -->
                @if (isMandatory()) {
                  <span class="invalidspan me-4"
                    ><i
                    class="fal fa-exclamation-circle"
                    tooltipClass="customTooltip"
                    [ngbTooltip]="app.text.field.requiredIcon"
                    ></i
                  ></span>
                }
              </div>
            }
            <!-- TIMESTAMP -->
            <!-- <div *ngSwitchCase="'timestamp'">
            <span *ngIf="model[field] != ''">
              {{ model[field] | date : "yyyy-MM-dd HH:mm:ss" }}
            </span>
          </div> -->
          <!-- DATA -->
          @case ('data') {
            <span> {{ model[field] | json }} </span>
          }
          <!-- CHECKBOX -->
          @case ('checkbox') {
            <span [title]="app.field.getTooltip(field)">
              @if (model[field] === true) {
                <i
                  [ngClass]="{ finalSol: isFinalSolutin }"
                  class="far fa-check-square mt-2"
                ></i>
              }
              @if (model[field] !== true) {
                <i class="far fa-square mt-2"></i>
              }
            </span>
          }
          <!-- TEXT -->
          @case ('text') {
            <div
              class="no-scroll"
          [ngClass]="{
            content: !differentDisplay
          }"
              >
              <div class="wrapper">
                @if (isEnabled() && !differentDisplay) {
                  <textarea
                    class="form-control m-0"
                    [name]="field"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory(),
                'maxHeight-30': getTextrareaRows(field) === 1,
                'minHeight-85': getTextrareaRows(field) === 4
              }"
                    [(ngModel)]="model[field]"
                    [disabled]="isDisabled()"
                    [maxLength]="calculateMaxLength(field)"
                    (keyup)="app.productCategory.searchWhileTyping(model[field])"
                    [rows]="getTextrareaRows(field)"
                    (focus)="setMultipleFocus(field)"
                    autosize
                  ></textarea>
                }
                @if (isMandatory()) {
                  <span class="invalidspan"
                    ><i
                    class="fal fa-exclamation-circle"
                    tooltipClass="customTooltip"
                    [ngbTooltip]="app.text.field.requiredIcon"
                    ></i
                  ></span>
                }
              </div>
              <slot>
                @if (!isEnabled()) {
                  <div
                    class="fake-textarea"
                    [innerHtml]="app.field.highlightLinks(model[field])"
                  ></div>
                }
              </slot>
              @if (differentDisplay) {
                <div class="input-group">
                  <div class="input-group-prepend">
                    @if (app.filterList.field != null) {
                      <button
                        class="btn btn-sm selected selectedFilter"
                (click)="
                  app.filterList.field = null; app.filterList.open = true
                "
                        type="button"
                        >
                        {{ app.field.getLabel(app.filterList.field) }}
                        <i class="fa fa-times app-subtle"></i>
                      </button>
                    }
                  </div>
                  <input
                    [maxLength]="calculateMaxLength(field)"
                    (focus)="searchFocus = true"
                    (blur)="blur()"
                    class="form-control m-0 lineHeight py-2 border"
              [ngClass]="{
                'underline-red': isMandatory(),
                underline: showUnderline()
              }"
                    type="text"
                    [name]="field"
                    [(ngModel)]="model[field]"
                    [disabled]="isDisabled()"
                    />
                  @if (differentDisplay) {
                    <span class="input-group-append">
                      <button
                        class="btn btn-outline-secondary border-left-0 border"
                        type="button"
                        (click)="app.filterList.add()"
                        >
                        <i class="fa fa-search"></i>
                        <span>&nbsp;{{ app.text.app.search }}</span>
                      </button>
                    </span>
                  }
                </div>
              }
            </div>
          }
          <!-- PASSWORD -->
          @case ('password') {
            <div>
              <div class="wrapper">
                <input
                  class="form-control m-0"
              [ngClass]="{
                underline: showUnderline()
              }"
                  type="password"
                  [name]="field"
                  [(ngModel)]="model[field]"
                  [disabled]="isDisabled()"
                  />
                @if (isMandatory()) {
                  <span class="invalidspan"
                    ><i
                    class="fal fa-exclamation-circle"
                    tooltipClass="customTooltip"
                    [ngbTooltip]="app.text.field.requiredIcon"
                    ></i
                  ></span>
                }
              </div>
            </div>
          }
          <!-- OPTIONS -->
          @case ('options') {
            <div
          [ngClass]="{
            underline: showUnderline(),
            'underline-red': isMandatory()
          }"
              class="lineHeight"
              >
              @if (!searchFocus || app.field.isMultipleSelected) {
                <div>
                  @if (app.filterList.field != null && differentDisplay) {
                    <button
                      class="btn btn-sm selected selectedFilter"
                      (click)="app.filterList.field = null; app.filterList.open = true"
                      type="button"
                      >
                      {{ app.field.getLabel(app.filterList.field) }}
                      <i class="fa fa-times app-subtle"></i>
                    </button>
                  }
                  @if (!isDisabled() && showSearchButton) {
                    <button
                      class="btn btn-sm pull-right"
                      (click)="startSearch()"
                      >
                      @if (!nonSearchableDropdowns && !app.field.isRequired(field)) {
                        <i
                          class="fa fa-search"
                        ></i>
                      }
                      @if (differentDisplay) {
                        <span
                          >&nbsp;{{ app.text.app.search }}</span
                          >
                        }
                      </button>
                    }
                    @if (
                      app.customer === 'coop' &&
                      field === 'thread.productCategory' &&
                      app.unlockedId === app.thread.id
                      ) {
                      <button
                        class="btn btn-sm btn-light pull-right show-all-btn"
                        (click)="app.productCategory.showAllCategories()"
                        >
                        Show all
                      </button>
                    }
                    @for (option of app.field.getOptions(field); track option) {
                      <span>
                        @if (app.field.isOptionSelected(field, option, model)) {
                          <span
                            class="dateBtn"
                            [ngClass]="{ noEvents: !app.thread.isEditMode() }"
                            >
                            @if (!isDisabled()) {
                              <button
                                class="btn btn-sm"
                                id="{{ field }}"
                  (click)="
                    $event.stopPropagation();
                    app.field.toggleOption(field, option, model)
                  "
                                >
                                <span
                                  tooltipClass="tree-category-tooltip"
                                  [ngbTooltip]="
                                    app.field.getOptionTooltipText(field, option)
                                  "
                                >
                                  {{ app.field.getOptionDisplayText(field, option) }}
                                </span>
                                @if (!isDisabled()) {
                                  <i
                                    class="fas fa-times-circle app-subtle displayIcon"
                                    (click)="clearModel(field, option)"
                                  ></i>
                                }
                              </button>
                            }
                            @if (isDisabled() && !getTreeStyle(field)) {
                              <button
                                class="btn btn-sm"
                                id="{{ field }}"
                                [ngStyle]="null"
                                >
                                <span
                                  tooltipClass="tree-category-tooltip"
                                  [ngbTooltip]="
                                    app.field.getOptionTooltipText(field, option)
                                  "
                                >
                                  {{ app.field.getOptionDisplayText(field, option) }}
                                </span>
                              </button>
                            }
                            @if (isDisabled() && getTreeStyle(field)) {
                              <span
                                class="badge text-center fieldValue-smaller"
                                [ngStyle]="app.field.getColor(field, option)"
                                >
                                <span
                                  tooltipClass="tree-category-tooltip"
                                  [ngbTooltip]="
                                    app.field.getOptionTooltipText(field, option)
                                  "
                                >
                                  {{ app.field.getOptionDisplayText(field, option) }}
                                </span>
                              </span>
                            }
                          </span>
                        }
                      </span>
                    }
                    <!-- Show model[field] (value saved in database) if the options array does not contain that value anymore -->
                    @if (displayValue(field, model[field])) {
                      <span
                        class="lineHeight-28"
                        >
                        {{ model[field] }}
                      </span>
                    }
                  </div>
                }
                <div
                  class="borderedInput m-0 p-0"
            [ngStyle]="{
              display:
                searchFocus && !app.field.isMultipleSelected ? 'block' : 'none'
            }"
                  >
                  <input
                    autocomplete="off"
                    #searchField
                    class="form-control m-0"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory()
              }"
                    name="search"
                    [(ngModel)]="search"
                    (focus)="searchFocus = true"
              [disabled]="
                (searchFocus === true && nonSearchableDropdowns) ||
                app.field.isMultipleSelected
              "
                    (blur)="blur()"
                    />
                </div>
                @if (
                  !app.field.isValid(field, model[field]) &&
                  app.field.isRequired(field) &&
                  app.filterList.field == null &&
                  !searchFocus
                  ) {
                  <span
                    class="invalidspan"
                    ><i
                    class="fal fa-exclamation-circle"
                    tooltipClass="customTooltip"
                    [ngbTooltip]="app.text.field.requiredIcon"
                  ></i>
                </span>
              }
              @if (searchFocus && !isMultipleField(field) && !isDisabled()) {
                <div>
                  <app-field-options
                    [field]="field"
                    [model]="model"
                    (selected)="onOptionSelected()"
                  ></app-field-options>
                </div>
              }
              @if (field === 'thread.applicationArea' && app.unlockedId) {
                <div>
                  <app-application-area></app-application-area>
                </div>
              }
            </div>
          }
          <!-- USER OPTIONS -->
          @case ('user-options') {
            <div
          [ngClass]="{
            underline: showUnderline(),
            'underline-red': isMandatory()
          }"
              class="lineHeight"
              >
              <div>
                <app-field-user-options
                  [field]="field"
                  [model]="model"
                  [disabled]="isDisabled()"
                ></app-field-user-options>
              </div>
            </div>
          }
          <!-- RADIO -->
          @case ('radio') {
            <div class="radio_input">
              @for (option of app.field.getOptions(field); track option) {
                <div
                  class="radio_input_value"
                  >
                  @if (!differentDisplay) {
                    <span>
                      <input
                        type="radio"
                        [name]="field"
                        value="{{ option }}"
                        [(ngModel)]="model[field]"
                        [disabled]="isDisabled() || hasPermissionToEdit()"
                        />
                    </span>
                  }
                  @if (differentDisplay) {
                    <span>
                      <input
                        type="radio"
                        [name]="field"
                        value="{{ option }}"
                        [(ngModel)]="model[field]"
                        (click)="onItemSelected(option, field)"
                        [disabled]="isDisabled() || hasPermissionToEdit()"
                        />
                    </span>
                  }
                  <label>{{ app.field.getOptionText(field, option) }}</label>
                </div>
              }
              @if (isMandatory()) {
                <span class="invalidspan"
                  ><i
                  class="fal fa-exclamation-circle"
                  tooltipClass="customTooltip"
                  [ngbTooltip]="app.text.field.requiredIcon"
                  ></i
                ></span>
              }
            </div>
          }
          <!-- TYPE NUMBER  -->
          @case ('number') {
            <div>
              @if (
                !showLabel && app.field.isRequired(field) && !differentDisplay
                ) {
                <span
                  class="pull-left changeColor"
                  >*
                </span>
              }
              @if (!differentDisplay) {
                <span>
                  <input
                    [maxlength]="this.app.field.getFieldSettings(field).maxLength"
                    (focus)="searchFocus = true; setMultipleFocus(field)"
                    (blur)="blur()"
                    class="form-control m-0 lineHeight"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory()
              }"
                    type="number"
                    [name]="field"
                    [(ngModel)]="model[field]"
                    [disabled]="isDisabled()"
                    />
                  @if (this.app.field.getFieldSettings(field).unit) {
                    <span
                      class="fieldUnit"
                      >{{
                      this.app.field.getFieldSettings(field).unit[this.app.language]
                      }}</span
                      >
                    }
                  </span>
                }
                @if (differentDisplay) {
                  <div class="input-group">
                    <input
                      [maxlength]="this.app.field.getFieldSettings(field).maxLength"
                      (focus)="searchFocus = true; setMultipleFocus(field)"
                      (blur)="blur()"
                      class="form-control m-0 lineHeight border-light"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory()
              }"
                      type="number"
                      [name]="field"
                      [(ngModel)]="model[field]"
                      [disabled]="isDisabled()"
                      />
                    <span class="input-group-append">
                      @if (differentDisplay) {
                        <button
                          class="btn btn-outline-secondary border-left-0 border"
                          type="button"
                          (click)="app.filterList.add()"
                          >
                          <i class="fa fa-search"></i>
                          <span>&nbsp;{{ app.text.app.search }}</span>
                        </button>
                      }
                    </span>
                  </div>
                }
                @if (isMandatory() && !differentDisplay && showLabel) {
                  <span
                    class="invalidspan"
                    ><i
                    class="fal fa-exclamation-circle"
                    tooltipClass="customTooltip"
                    [ngbTooltip]="app.text.field.requiredIcon"
                    ></i
                  ></span>
                }
              </div>
            }
            @case ('typeahead') {
              <div>
                @if (differentDisplay) {
                  <div class="searchContainer">
                    @if (app.filterList.field != null) {
                      <button
                        class="btn btn-sm selected selectedFilter"
                        (click)="app.filterList.field = null; app.filterList.open = true"
                        type="button"
                        >
                        {{ app.field.getLabel(app.filterList.field) }}
                        <i class="fa fa-times app-subtle"></i>
                      </button>
                    }
                    <app-typeahead-basic
                      class="typeahead"
                      [field]="field"
                      [docModel]="model"
                      [maxLength]="calculateMaxLength(field)"
                      [placeholder]="typeaheadPlaceholder"
                    ></app-typeahead-basic>
                  </div>
                }
                @if (!differentDisplay) {
                  <div>
                    <app-typeahead-basic
                      [field]="field"
                      [docModel]="model"
                      [maxLength]="calculateMaxLength(field)"
                      [placeholder]="typeaheadPlaceholder"
                    ></app-typeahead-basic>
                  </div>
                }
              </div>
            }
            @case ('dataList') {
              <div>
                @if (!isDisabled()) {
                  <div class="position-relative">
                    @if (
                      app.field.isMultiple(field) &&
                      getSelectedDataListValues().length
                      ) {
                      <div
                        class="datalist-selected-options"
                        >
                        @for (value of getSelectedDataListValues(); track value) {
                          <span
                            class="datalist-selected-chip me-1 mb-1"
                            >
                            {{ value }}
                            <i
                              class="fas fa-times-circle datalist-remove-option"
                              (click)="removeDataListValue(value)"
                            ></i>
                          </span>
                        }
                      </div>
                    }
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                [ngClass]="{
                underline: showUnderline()
              }"
                        [(ngModel)]="query"
                        [disabled]="isDisabled()"
                        (focus)="open()"
                        (input)="onType()"
                        (blur)="closeWithDelay()"
                        (keydown.enter)="addIfNew()"
                        [class.bg-light]="isSpecialView"
                        [class.bg-secondary-subtle]="isSpecialView"
                        [class.border-secondary]="isSpecialView"
                        />
                    </div>
                    @if (showSuggestions) {
                      <div
                        class="dropdown-menu show mt-1 position-static datalist-dropdown-menu"
                        >
                        @for (opt of filteredOptions; track opt) {
                          <button
                            type="button"
                            class="dropdown-item datalist-dropdown-item"
                            (mousedown)="select(opt)"
                            >
                            @if (
                              app.field.isMultiple(field) && isDataListValueSelected(opt)
                              ) {
                              <i
                                class="far fa-check-square mt-2"
                              ></i>
                            }
                            @if (!isDataListValueSelected(opt)) {
                              <i
                                class="far fa-square mt-2"
                              ></i>
                            }
                            {{ opt }}
                          </button>
                        }
                        @if (!filteredOptions.length) {
                          <div
                            class="list-group-item list-group-item-action"
                            >
                            No results
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (isDisabled()) {
                  <div>
                    {{
                    app.field.isMultiple(field)
                    ? getSelectedDataListValues().join(", ")
                    : model[field]
                    }}
                  </div>
                }
              </div>
            }
            @case ('projectNumber') {
              <div>
                <div class="wrapper">
                  <div class="input-group flex-nowrap m-0">
                    <div class="input-group-prepend hashTagSign">AeA -</div>
                    <input
                      class="form-control m-0 lineHeight"
                [ngClass]="{
                  underline: showUnderline(),
                  'underline-red': isMandatory(),
                  orangeInput: orangeField
                }"
                      type="text"
                      [name]="field"
                      [ngModel]="getProjectNumberSuffix(model[field])"
                      (ngModelChange)="onProjectNumberChange($event)"
                      [disabled]="isDisabled()"
                      minlength="3"
                      maxlength="5"
                      pattern="[0-9]{3,5}"
                      [placeholder]="isDisabled() ? '' : 'e.g. 001 or 01234'"
                      inputmode="numeric"
                      (keypress)="allowOnlyDigits($event)"
                      (paste)="onProjectNumberPaste($event)"
                      (focus)="searchFocus = true; setMultipleFocus(field)"
                      (blur)="blur()"
                      />
                    @if (app.unlockedId) {
                      <span class="invalidspan me-4"
                        ><i
                        class="fal fa-exclamation-circle"
                        tooltipClass="customTooltip"
                        [ngbTooltip]="app.text.field.projectNumber"
                        ></i
                      ></span>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- DEFAULT / VALUE -->
            @default {
              <div>
                @if (
                  !showLabel &&
                  !labelInside &&
                  app.field.isRequired(field) &&
                  !differentDisplay
                  ) {
                  <span
                    class="pull-left changeColor"
                    >*</span
                    >
                  }
                  @if (
                    getFieldType(field, model[field]) === specialCharacter &&
                    !differentDisplay
                    ) {
                    <div
                      class="input-group mb-3"
                      >
                      <div class="input-group-prepend hashTagSign">#</div>
                      <input
                        [maxLength]="calculateMaxLength(field)"
                        (focus)="searchFocus = true; setMultipleFocus(field)"
                        (blur)="blur()"
                        class="form-control m-0 lineHeight"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory()
              }"
                        type="text"
                        [name]="field"
                        [(ngModel)]="model[field]"
                        [disabled]="isDisabled()"
                        />
                    </div>
                  }
                  @if (differentDisplay) {
                    <div class="input-group">
                      <div class="input-group-prepend">
                        @if (app.filterList.field != null) {
                          <button
                            class="btn btn-sm selected selectedFilter"
                (click)="
                  app.filterList.field = null; app.filterList.open = true
                "
                            type="button"
                            >
                            {{ app.field.getLabel(app.filterList.field) }}
                            <i class="fa fa-times app-subtle"></i>
                          </button>
                        }
                      </div>
                      <input
                        [maxLength]="calculateMaxLength(field)"
                        (focus)="searchFocus = true; setMultipleFocus(field)"
                        (blur)="blur()"
                        class="form-control m-0 lineHeight py-2 border"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory()
              }"
                        type="text"
                        [name]="field"
                        [(ngModel)]="model[field]"
                        [disabled]="isDisabled()"
                        />
                      <span class="input-group-append">
                        @if (differentDisplay) {
                          <button
                            class="btn btn-outline-secondary border-left-0 border"
                            type="button"
                            (click)="app.filterList.add()"
                            >
                            <i class="fa fa-search"></i>
                            <span>&nbsp;{{ app.text.app.search }}</span>
                          </button>
                        }
                      </span>
                    </div>
                  }
                  <div class="wrapper">
                    @if (
                      getFieldType(field, model[field]) === normal &&
                      !differentDisplay &&
                      !app.field.isHyperLink(field, model[field])
                      ) {
                      <input
                        [maxLength]="calculateMaxLength(field)"
                        (focus)="searchFocus = true; setMultipleFocus(field)"
                        (blur)="blur()"
              (keyup)="
                app.field.isValidRegex(field, model[field]);
                replaceSpecialCharacters(field)
              "
                        class="form-control m-0 lineHeight"
              [ngClass]="{
                underline: showUnderline(),
                'underline-red': isMandatory(),
                orangeInput: orangeField
              }"
                        type="text"
                        [name]="field"
                        [(ngModel)]="model[field]"
                        [disabled]="isDisabled()"
                        />
                    }
                    @if (isMandatory() && !orangeField && showLabel) {
                      <span
                        class="invalidspan"
                        ><i
                        class="fal fa-exclamation-circle"
                        tooltipClass="customTooltip"
                        [ngbTooltip]="app.text.field.requiredIcon"
                        ></i
                      ></span>
                    }
                  </div>
                  @if (
                    field == 'user.email' &&
                    app.field.hasRegex(field) &&
                    !app.field.isValidRegex(field, model[field])
                    ) {
                    <div
                      class="highlight-text"
                      >
                      {{ app.text.field.emailFormat }}
                    </div>
                  }
                  @if (app.field.isHyperLink(field, model[field])) {
                    <a
                      class="lineHeight-26 link"
                      (click)="app.routing.openInNewTab(null, field, model[field])"
                      >{{ model[field] }}</a
                      >
                    }
                    @if (getFieldType(field, model[field]) === externalFile) {
                      <a
                        class="externalFile-icon"
                        target="_blank"
                        [href]="model[field]"
                        >
                        <i class="fas fa-file pt-2"></i>
                      </a>
                    }
                    @if (getFieldType(field, model[field]) === file) {
                      <button
                        class="externalFile-icon downloadFile"
                        (click)="downloadFile(field)"
                        >
                        <i class="fas fa-file pt-2"></i>
                      </button>
                    }
                    @if (getFieldType(field, model[field]) === upload) {
                      <span
                        class="btn p-0"
                        [ngClass]="{ noEvents: app.unlockedId != null }"
                        (click)="fileInput.click()"
                        >
                        <i class="fa fa-upload"></i>
                      </span>
                    }
                    @if (getFieldType(field, model[field]) === attachment) {
                      <div
                        class="btn p-0 col-md-12"
                        >
                        @if (app.field.isLink(model[field])) {
                          <a
                            class="attachment-link pull-left"
                            target="_blank"
                            [href]="model[field]"
                            >
                            {{ app.attachment.getDocNameByFieldId(field) }}
                          </a>
                        }
                        @if (!app.field.isLink(model[field])) {
                          <span
                            class="attachment-link pull-left"
                            (click)="downloadDocAttachedToField(field)"
                            >
                            {{ app.attachment.getDocNameByFieldId(field) }}
                          </span>
                        }
                        <span class="float-end pe-1" (click)="deleteAttachmentModal.open()">
                          <i class="fa fa-trash"></i>
                        </span>
                      </div>
                    }
                    @if (getFieldType(field, model[field]) === modal) {
                      <span
                        class="btn p-0"
                        (click)="onModalIconClicked($event)"
                        >
                        <i
                          class="fas"
              [ngClass]="{
                'fa-map-marker-alt':
                  field === app.fieldId.manufacturer.manufacturingLocations,
                'fa-clone':
                  field !== app.fieldId.manufacturer.manufacturingLocations
              }"
                        ></i>
                      </span>
                    }
                    @if (this.app.field.getFieldSettings(field).unit && model[field]) {
                      <span
                        class="fieldUnit"
                        >{{
                        this.app.field.getFieldSettings(field).unit[this.app.language]
                        }}
                      </span>
                    }
                    @if (searchFocus) {
                      <app-field-options
                        [field]="field"
                        [model]="model"
                        [searchText]="model[field]"
                        (selected)="selectOption($event)"
                      ></app-field-options>
                    }
                  </div>
                }
              }
            </div>
          </div>
          <!-- display message if there are cases created from the current selected cpn/mpn currently available for NS only -->
          @if (
            app.fieldId.thread.artNumber === field &&
            app.field.displayCassesPerCpn &&
            !differentDisplay &&
            model[field]
            ) {
            <span
              class="col-md-12 d-flex existingCasesText"
              >
              @if (app.thread.existingCasesPerCpn.length !== 0) {
                <small
                  class="p-1 ps-1 ms-2"
        [ngClass]="{
          'show-less': isShortened,
          'text-red':
            app.customer === 'ruagch' ||
            app.customers.expectCurrent === 'ruagch'
        }"
                  >
                  {{ app.text.thread.casesCreatedByCPN }}
                  @for (case of app.thread.existingCasesPerCpn; track case) {
                    <span
                      class="badge badge-sm pointer"
                      >
                      &nbsp;<a
                      class="font-weight-bold navLink"
                      (click)="app.routing.navigateThread(case.id)"
                      [routerLink]="navigateToCase(case.id)"
                      >{{ case.omfNumber }}</a
                      >&nbsp;
                    </span>
                  }
                </small>
              }
              @if (app.thread.existingCasesPerCpn.length > 6) {
                <button
                  class="btn btn-sm isText"
                  type="button"
                  (click)="showMore(); $event.stopPropagation()"
                  [title]="app.text.thread.showMore"
                  >
                  @if (isShortened) {
                    <i class="fas fa-chevron-down"></i>
                  }
                  @if (!isShortened) {
                    <i class="fas fa-chevron-up"></i>
                  }
                </button>
              }
            </span>
          }
          @if (
            app.fieldId.thread.crtNumber === field &&
            app.field.displayCassesPerMpn &&
            !differentDisplay &&
            model[field]
            ) {
            <span
              class="col-md-12 existingCasesText"
              >
              @if (app.thread.existingCasesPerMpn.length !== 0) {
                <small
                  class="p-1 ps-1 ms-2"
        [ngClass]="{
          'show-less': isShortened,
          'text-red':
            app.customer === 'ruagch' ||
            app.customers.expectCurrent === 'ruagch'
        }"
                  >
                  {{ app.text.thread.duplicateCrtNumber }}
                  @for (case of app.thread.existingCasesPerMpn; track case) {
                    <span
                      class="badge badge-sm pointer"
                      >
                      &nbsp;<a
                      class="font-weight-bold navLink"
                      (click)="app.routing.navigateThread(case.id)"
                      [routerLink]="navigateToCase(case.id)"
                      >{{ case.omfNumber }}</a
                      >&nbsp;
                    </span>
                  }
                </small>
              }
              @if (app.thread.existingCasesPerMpn.length > 6) {
                <button
                  class="btn btn-sm isText"
                  type="button"
                  (click)="showMore(); $event.stopPropagation()"
                  [title]="app.text.thread.showMore"
                  >
                  @if (isShortened) {
                    <i class="fas fa-chevron-down icon-style"></i>
                  }
                  @if (!isShortened) {
                    <i class="fas fa-chevron-up icon-style"></i>
                  }
                </button>
              }
            </span>
          }
          @if (
            app.fieldId.thread.pcnID === field &&
            app.field.displayCassesPerPcnId &&
            !differentDisplay &&
            model[field]
            ) {
            <span
              class="col-md-12 existingCasesText"
              >
              @if (app.thread.existingCasesPerPcnId.length !== 0) {
                <small
                  class="p-1 ps-1 ms-2"
        [ngClass]="{
          'show-less': isShortened,
          'text-red':
            app.customer === 'ruagch' ||
            app.customers.expectCurrent === 'ruagch'
        }"
                  >
                  {{ app.text.thread.duplicatePcnId }}
                  @for (case of app.thread.existingCasesPerPcnId; track case) {
                    <span
                      class="badge badge-sm pointer"
                      >
                      &nbsp;<a
                      class="font-weight-bold navLink"
                      (click)="app.routing.navigateThread(case.id)"
                      [routerLink]="navigateToCase(case.id)"
                      >{{ case.omfNumber }}</a
                      >&nbsp;
                    </span>
                  }
                </small>
              }
              @if (app.thread.existingCasesPerPcnId.length > 6) {
                <button
                  class="btn btn-sm px-3 isText"
                  type="button"
                  (click)="showMore(); $event.stopPropagation()"
                  [title]="app.text.thread.showMore"
                  >
                  @if (isShortened) {
                    <i class="fas fa-chevron-down icon-style"></i>
                  }
                  @if (!isShortened) {
                    <i class="fas fa-chevron-up icon-style"></i>
                  }
                </button>
              }
            </span>
          }
          <!-- end -->
        </div>
      </div>
